module.exports = __webpack_public_path__ + "media/images/category/feature/coj_f/logo-coj-ja-848db17f730dcac9a9b5c4ec9aa35af4.png";